module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Glossary"
    }
  }, [_c('p', {
    staticClass: "h1",
    attrs: {
      "id": "ch-4"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xiii",
      "title": "xiii"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Contents#ch4"
    }
  }, [_c('b', [_vm._v("GLOSSARY")])])])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("Atta")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Wheat flour")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("Attap")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Malayan hut made of palm leaves")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("Blitzkrieg")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Literal meaning: lightning war; this term is usually applied to explain the fast, mobile armored war practiced by the Germans in Europe and Russia between 1939 and 1942")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("Bushido")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Way of the Japanese warrior")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("Dharma")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Religion")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("Izzat")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("An Urdu word that stands for personal reputation")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("Jawan")])]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Literal meaning: young man; the term refers to an Indian private")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("Kesselschlacht/Kettelschlacht")])]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Cauldron Battle, which involved pinning down the enemy’s army frontally and enveloping its two wings and rear")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("Kikan")])]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Agency/department/section")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("Kukri")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Curved knife used by the Gurkha soldier")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("Luftwaffe")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("German Air Force during the Second World War")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("Mai-baap")])]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Literal meaning: father figure; a "), _c('i', [_vm._v("jawan")]), _vm._v(" looked up to his commanding British officer as a "), _c('i', [_vm._v("mai-baap")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("Parang")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("A machete or cleaver used by the Malays")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("Raj")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Literal meaning: realm; the term refers to the British government in India")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("Sahib")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("British officer of the Indian Army")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("Sampan")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Large Chinese country boat used by the “natives” in Malaya")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("Sepoy")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("This term refers to the Indian infantry; the word is derived from the Persian word "), _c('i', [_vm._v("sipahi")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("Sirdar")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Chieftain")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("Wehrmacht")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("German armed force during the Second World War"), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xiv",
      "title": "xiv"
    }
  })])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e7bb641","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253044174_Glossary.vue
// module id = 84
// module chunks = 0